import React from "react";
import { useNavigate } from "react-router-dom";

const AccountVerifiedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="container d-flex flex-column justify-content-center align-items-center vh-100">
      <div className="card shadow-lg p-4 text-center" style={{ maxWidth: "500px" }}>
        <h2 className="text-success mb-3">
          <i className="fa fa-check-circle me-2" /> Account Verified
        </h2>
        <p className="mb-4">
          Your account has been successfully verified and kids have been added.
          <br />
          You can now access your dashboard by logging in.
        </p>
        <button
          className="btn btn-outline-primary"
          onClick={() => navigate("/")}
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default AccountVerifiedPage;
